var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 29
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.05 25.107 31.556 4.601l-.707-.708L11.05 23.692l-9.899-9.899-.707.707L11.05 25.107z"
  })));
};
export { SvgCheck as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIyOSIgdmlld0JveD0iMCAwIDMyIDI5Ij48dGl0bGU+Y2hlY2s8L3RpdGxlPjxwb2x5Z29uIHBvaW50cz0iMTEuMDUgMjUuMTA3IDMxLjU1NiA0LjYwMSAzMC44NDkgMy44OTMgMTEuMDUgMjMuNjkyIDEuMTUxIDEzLjc5MyAwLjQ0NCAxNC41IDExLjA1IDI1LjEwNyIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg==";